import type { SVGProps } from 'react';

const SvgOneClick = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="one-click">
      <path d="m23.93 17.46.55-.31a2 2 0 0 0-.48-3.72l-10.69-3A2 2 0 0 0 10.83 13l3.23 10.6a2 2 0 0 0 3.72.42l.4-.7a.78.78 0 0 1 .58-.39.79.79 0 0 1 .67.22l3.05 3a2.31 2.31 0 0 0 3.21 0l1.06-1a2.31 2.31 0 0 0 0-3.25l-3-3.09a.82.82 0 0 1-.22-.67.79.79 0 0 1 .4-.68m-1.24 2.3 3 3.09a.74.74 0 0 1 .22.56.8.8 0 0 1-.24.57l-1.05 1a.8.8 0 0 1-1.12 0l-3.05-3a2.27 2.27 0 0 0-1.61-.66h-.32a2.31 2.31 0 0 0-1.68 1.14l-.39.7a.54.54 0 0 1-1-.11l-3.18-10.54a.51.51 0 0 1 .13-.51.5.5 0 0 1 .52-.14l10.69 3a.53.53 0 0 1 .12 1l-.54.31a2.29 2.29 0 0 0-.5 3.6Z" />
      <path d="M30.36 21.79A15.48 15.48 0 1 0 16 31.48a15.3 15.3 0 0 0 6.43-1.4l-.62-1.36A14 14 0 1 1 29 21.23Z" />
    </g>
  </svg>
);

export default SvgOneClick;
